import { Close, CloseFullscreen, OpenInFull } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, Tab, Tabs } from "@mui/material";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import { Encounters, Orders, PaperComponent, PatientInfo, TabPanel, Appointments } from "./Components";
import * as c from "../../../utils/constants/constants";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const EhrPopup = (props) => {

    const { data = {} } = useContext(DocumentDetailContext);

    const popupDefaultPosition = {
        height: 840,
        y: 20,
    };

    const [selectedTab, setSelectedTab] = useState(null);
    const [size, setSize] = useState({ width: window.innerWidth * 0.75, height: popupDefaultPosition.popupHeight });
    const [maximise, setMaximise] = useState(true);
    const [popupPosition, updatePopupPosition] = useState({ x: (window.innerWidth - size.width) / 4, y: popupDefaultPosition.y });
    const [selectedEncApp, setSelectedEncApp] = useState(null);

    useEffect(() => {
        const { ehrDetails: { encounter } = {}, classify: { documentLevel } = {} } = data?.Entity_Details || {};
        setSelectedEncApp(encounter?.identifier || null);

        if (data.Status == c.status.intervention_rqd && !data.MRN) {
            setSelectedTab(0)
        } else {
            setSelectedTab(documentLevel === "Encounter" ? 1 : documentLevel === "Order" ? 3 : 0)
        }
    }, [data?.Entity_Details?.classify?.documentLevel, data.Status, data?.MRN]);

    useEffect(() => {
        if (maximise) {
            setSize({
                width: window.innerWidth * 0.75, height: window.innerHeight * 0.7,
                height: popupDefaultPosition.popupHeight
            });
            updatePopupPosition({ x: (window.innerWidth - size.width) / 4, y: popupDefaultPosition.y })
        } else {
            setSize({
                width: (window.innerWidth / 2) - 60,
                height: popupDefaultPosition.popupHeight
            });
            updatePopupPosition({ x: 35, y: popupDefaultPosition.y });
        }
    }, [maximise]);

    return <Dialog
        className="EHR"
        open={props.openEhrPopup}
        PaperComponent={PaperComponent}
        hideBackdrop
        disableEnforceFocus
        disableScrollLock
        // container={() => document.getElementById('ehr-popup-mount-container')}
        PaperProps={{
            size,
            draggablePosition: popupPosition
        }}
        sx={{
            width: size.width,
            height: size.height
        }}
        slotProps={{
            root: {
                sx: {
                    position: "absolute",
                },
            },
        }}
    >
        <DialogTitle className="title-bg" id="draggable-dialog-title" style={{ cursor: 'move' }}>
            <div className="upload-title">
                <div className="ehr-popup-header">
                    <div style={{ marginRight: "20px" }}>EHR DETAILS</div>
                    {data.Entity_Details?.patientMatch?.official_name && <>
                        <div>Patient Name: {data.Entity_Details?.patientMatch?.official_name}</div>
                        <div className="ehr-popup-vertical-divider" ></div>
                    </> }
                    {data.Entity_Details?.patientMatch?.DOB && <>
                        <div>DOB: {data.Entity_Details?.patientMatch?.DOB}</div>
                        <div className="ehr-popup-vertical-divider" ></div></>}
                    {data.MRN && <>
                        <div>Patient MRN: {data.MRN}</div>
                        <div className="ehr-popup-vertical-divider" ></div>
                    </>}
                    <div>Sub-Category: {data.Entity_Details.classify.documentSubCategory}</div>
                    <div className="ehr-popup-vertical-divider" ></div>
                    <div>Document Level: {data.Entity_Details.classify.documentLevel}</div>
                </div>
                <div style={{ paddingLeft: "20px", display: "flex" }}>
                    {maximise ?
                        <CloseFullscreen onClick={() => setMaximise(false)} style={{ color: "white", cursor: "pointer" }} /> :
                        <OpenInFull onClick={() => setMaximise(true)} style={{ color: "white", cursor: "pointer" }} />}

                    <Close
                        style={{ color: "white", cursor: "pointer", paddingLeft: "10px" }}
                        onClick={() => props.setEhrPopup(false)}
                    />
                </div>


            </div>
        </DialogTitle>

        <DialogContent>
            <div className="ehr-popup-size" style={{ width: size.width, height: size.height }}>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                            value={selectedTab}
                            onChange={(e, value) => setSelectedTab(value)}
                            variant="fullWidth"
                            aria-label="basic tabs example"
                        >
                            <Tab label="Patient Info" value={0} {...a11yProps(0)} />
                            <Tab label="Encounters" value={1} {...a11yProps(1)} />
                            <Tab label="Appointments" value={2} {...a11yProps(2)} />
                            <Tab label="Orders" value={3} {...a11yProps(3)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                        <PatientInfo {...props} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <Encounters {...props} selectedTab={selectedTab} selected={selectedEncApp} setSelectedEncApp={setSelectedEncApp}/>
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                        <Appointments {...props} selectedTab={selectedTab} selected={selectedEncApp} setSelectedEncApp={setSelectedEncApp}/>
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3}>
                        <Orders  {...props} selectedTab={selectedTab} />
                    </TabPanel>
                    
                </Box>
            </div>
        </DialogContent>
    </Dialog>
}

export default EhrPopup;